import { render, staticRenderFns } from "./customPagination.vue?vue&type=template&id=3b159921&scoped=true"
import script from "./customPagination.vue?vue&type=script&lang=js"
export * from "./customPagination.vue?vue&type=script&lang=js"
import style0 from "./customPagination.vue?vue&type=style&index=0&id=3b159921&prod&scoped=true&lang=css"
import style1 from "./customPagination.vue?vue&type=style&index=1&id=3b159921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b159921",
  null
  
)

export default component.exports